import { AttachmentType } from "@docma-mm-core/attachment/attachment-type";
import { ViewFault } from "@docma-mm-core/fault/fault";

export function getPlanSectionIndexForFault(fault: ViewFault): number {
    const planSections = fault.attachments.filter(f => f.data.Type == AttachmentType.PlanSection).sort((a, b) => b.data.ModifiedOn.getTime() - a.data.ModifiedOn.getTime());
        
    if(planSections.length > 0) {
        const regex = /\d+/;
        const latestFileName = planSections[0].data.OriginalFileName || planSections[0].data.Description
        const regexResult = latestFileName.match(regex);
        if(regexResult && regexResult.length > 0) {
        return Number(regexResult[0]);
        }
    }  
    return 0;
}